export default __webpack_public_path__ + "images/0x36912b5cf63e509f18e53ac98b3012fa79e77bf5.png";